/* Black Diamond Enterprises — theme JS
   Mobile menu, scrolling strip, reveal-on-scroll, AJAX cart drawer, YouTube watch config. */
(function () {
  "use strict";

  /* ---------- Mobile menu ---------- */
  var hamb = document.querySelector('[data-hamb]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (hamb && menu) {
    hamb.addEventListener('click', function () {
      menu.classList.toggle('open');
      hamb.classList.toggle('active');
    });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { menu.classList.remove('open'); hamb.classList.remove('active'); });
    });
  }

  /* ---------- Header background on scroll ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.style.background = window.scrollY > 20 ? 'rgba(11,11,13,.95)' : 'rgba(11,11,13,.82)';
    }, { passive: true });
  }

  /* ---------- Scrolling strip: duplicate tiles for a seamless loop ---------- */
  document.querySelectorAll('[data-marquee-track]').forEach(function (track) {
    if (track.children.length && !track.dataset.doubled) {
      track.innerHTML += track.innerHTML;
      track.dataset.doubled = '1';
    }
  });

  /* ---------- Reveal on scroll ---------- */
  var io;
  function observeReveals() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.12 });
    }
    document.querySelectorAll('.reveal:not(.in)').forEach(function (el) { io.observe(el); });
  }
  observeReveals();
  document.addEventListener('shopify:section:load', observeReveals);

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = document.getElementById('bde-toast');
    if (!t) { t = document.createElement('div'); t.id = 'bde-toast'; t.className = 'toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('show');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2200);
  }

  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  /* ---------- AJAX cart ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var backdrop = document.querySelector('[data-cart-backdrop]');
  var body = document.querySelector('[data-cart-body]');
  var foot = document.querySelector('[data-cart-foot]');

  function openCart() { if (drawer) { drawer.classList.add('open'); backdrop.classList.add('show'); } }
  function closeCart() { if (drawer) { drawer.classList.remove('open'); backdrop.classList.remove('show'); } }

  document.querySelectorAll('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); refreshCart(); openCart(); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  if (backdrop) backdrop.addEventListener('click', closeCart);

  function updateCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n; el.hidden = n === 0;
    });
  }

  function renderDrawer(cart) {
    if (!body) return;
    updateCount(cart.item_count);
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p><p style="font-size:13px;margin-top:8px">Add setups, templates, or services to get started.</p></div>';
      if (foot) foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image : '';
      return '<div class="di">' +
        (img ? '<img src="' + img + '" alt="">' : '<span class="livery" style="width:64px;height:44px;border:1px solid var(--line)"></span>') +
        '<div><div class="n">' + it.product_title + '</div>' +
        '<div class="c">' + (it.product_type || '') + '</div>' +
        '<div class="qty" style="margin-top:6px"><a href="#" data-qty="-1" data-key="' + it.key + '">−</a>' +
        '<input value="' + it.quantity + '" readonly><a href="#" data-qty="1" data-key="' + it.key + '">+</a></div></div>' +
        '<div style="text-align:right"><div class="ci-price" style="font-family:Oswald;font-weight:600">' + money(it.final_line_price) + '</div>' +
        '<button class="ci-remove" data-remove="' + it.key + '" style="background:none;border:none;color:var(--muted);cursor:pointer;font-size:12px;margin-top:6px">Remove</button></div>' +
        '</div>';
    }).join('');
    if (foot) {
      foot.hidden = false;
      var totalEl = foot.querySelector('[data-cart-total]');
      if (totalEl) totalEl.textContent = money(cart.total_price);
    }
    body.querySelectorAll('[data-qty]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var line = cart.items.filter(function (i) { return i.key === a.dataset.key; })[0];
        var q = line.quantity + parseInt(a.dataset.qty, 10);
        changeItem(a.dataset.key, Math.max(0, q));
      });
    });
    body.querySelectorAll('[data-remove]').forEach(function (b) {
      b.addEventListener('click', function () { changeItem(b.dataset.remove, 0); });
    });
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderDrawer)
      .catch(function () {});
  }

  function changeItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderDrawer).catch(function () {});
  }

  // Intercept add-to-cart forms for AJAX + drawer
  document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      }).then(function (r) { return r.json(); })
        .then(function (item) {
          toast('Added: ' + (item.product_title || 'item'));
          return refreshCart();
        })
        .then(function () { openCart(); })
        .catch(function () { toast('Could not add to cart'); })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  });

  // initialize count on load
  refreshCart();

  /* ---------- Watch page (YouTube) ---------- */
  var watch = document.querySelector('[data-watch]');
  if (watch) {
    var videoId = watch.dataset.video || '';
    var channelId = watch.dataset.channel || '';
    var chatDomain = watch.dataset.domain || window.location.hostname;
    var player = watch.querySelector('[data-player]');
    var chat = watch.querySelector('[data-chat]');
    var src = videoId ? 'https://www.youtube.com/embed/' + videoId
      : (channelId ? 'https://www.youtube.com/embed/live_stream?channel=' + channelId : '');
    if (src && player) {
      player.innerHTML = '<iframe src="' + src + '" title="Stream" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
    }
    if (videoId && chat) {
      chat.innerHTML = '<iframe src="https://www.youtube.com/live_chat?v=' + videoId + '&embed_domain=' + chatDomain + '" title="Live chat"></iframe>';
    }
  }
})();
